export default __webpack_public_path__ + "static/media/avatar_tommy_pyper1.8abbac75.mp3";